import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Person  } from "src/classes/Person";
import { Vehicle } from "src/classes/vehicle/Vehicle";
import { Util } from "src/utils/Util";
import { PlanManagementAction } from "../actions/plan-management.action";
import { IPlanCouponForm } from "../interfaces/IPlanCouponForm";
import { PlanManagementSelector } from "../selectors/plan-management.selector";


export namespace PlanManagementCouponFacade {

  const COUPON_ERRORS: TFormErrorMessage[] = [
    {
      key: 'pattern',
      message: 'El cupón ingresado no es válido.'
    },
  ]

  /**
   * 
   */
  export const usePlanCouponForm = (user: Person, vehicle: Vehicle, rfc?: string) => {
    const currentCoupon = useSelector(PlanManagementSelector.currentCoupon);
    const currentCoverages = useSelector(PlanManagementSelector.coverages);
    const { register, handleSubmit, formState: { errors }, getValues, setValue } = useForm<IPlanCouponForm>(
      {
        mode: 'onChange',
        reValidateMode: 'onChange',
      }
    );
    const dispatch = useDispatch();

    useEffect(() => {
      if (currentCoupon && !getValues().coupon) {
        setValue('coupon', currentCoupon);
      } else if (currentCoupon === '' && getValues().coupon) {
        setValue('coupon', '');
      }
    }, [currentCoupon, getValues, setValue])

    /**
     * 
     */
    const onApplyCoupon = (): void => {
      if (!currentCoupon) {
        if (Util.PATTERN.PLAN_COUPON.test(getValues().coupon)) {
          dispatch(PlanManagementAction.customizationState(true));
          dispatch(PlanManagementAction.quotation({ vehicle: vehicle, user: user, coupon: getValues().coupon, coverages: currentCoverages, rfc: rfc }));
        }
      } else if (currentCoupon) {
        dispatch(PlanManagementAction.customizationState(true));
        dispatch(PlanManagementAction.quotation({ vehicle: vehicle, user: user, coupon: '', coverages: currentCoverages, rfc: rfc }));
      }

    }

    return { register, handleSubmit, formState: { errors }, COUPON_ERRORS, currentCoupon, onApplyCoupon }
  }

}